import s from "../css/message.css";
import classnames from "classnames";
import copy from "copy-to-clipboard";

function create(info, classname, time = 3500) {
  let div = document.createElement("em");
  let timer = null;
  div.className = classnames(
    ["g-message"],
    window.localStorage.pageMode == "light" ? "" : "g-message-dark",
    classname
  );

  div.innerHTML = `<span>${info} </span>`;
  if (!window.document.querySelector("#msgbox")) {
    createBox();
  }
  div.onclick = function () {
    copy(info);
    clearTimeout(timer);
    close();
  };

  function close() {
    div.className = classnames(
      ["g-message"],
      window.localStorage.pageMode == "light" ? "" : ["g-message-dark"],
      classname,
      ["close"]
    );
    setTimeout(() => {
      div.parentNode.removeChild(div);
    }, 500);
  }

  window.document.querySelector("#msgbox").appendChild(div);
  timer = setTimeout(close, time);
}

function createBox() {
  if (window.document.querySelector("#msgbox")) return;
  let div = document.createElement("div");
  div.id = "msgbox";
  div.className = ["g-msgbox"];
  window.document.body.appendChild(div);
}
window.addEventListener("load", createBox, false);

function info(msg, t) {
  if (!msg) {
    return;
  }
  create(msg, null, t);
}
function warn(msg, t) {
  if (!msg) {
    return;
  }
  create(msg, ["warn"], t);
}
function error(msg, t) {
  if (!msg) {
    return;
  }
  create(msg, ["error"], t);
}
function success(msg, t) {
  if (!msg) {
    return;
  }
  create(msg, ["success"], t);
}
//点卡页面提示用
function tip(msg, t) {
  create(msg, ["success"], t);
}

export default {
  info,
  warn,
  error,
  success,
  tip,
};
